import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      flowType: "pkce",
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true,
    },
  }
);

/* Local, network-free identity. supabase.auth.getUser() round-trips to
   /auth/v1/user on every call, so offline it always fails — which broke
   offline outbox enqueues and cache reads (CODE-REVIEW.md H1/H2). The uid
   from the persisted session is only used client-side for cache keys,
   payload stamping, and query filters; RLS and RPCs re-verify the JWT
   server-side regardless, so nothing security-relevant trusts this value.

   lastUid covers the deep-offline edge: getSession() returns null when the
   access token expired and can't refresh (no network), but the auth state
   listener has already seen the stored session, so we still know who was
   signed in. Sign-out (any tab) clears it. */
let lastUid = null;
supabase.auth.onAuthStateChange((_event, session) => {
  lastUid = session?.user?.id ?? null;
});

export async function getUid() {
  try {
    const { data: { session } = {} } = await supabase.auth.getSession();
    if (session?.user?.id) lastUid = session.user.id;
  } catch {
    /* fall through to lastUid */
  }
  return lastUid;
}

/* Synchronous variant for callers that can't await (outbox enqueue). By the
   time a write fails during play, the auth listener has long since seen the
   session, so lastUid is populated. */
export function getUidSync() {
  return lastUid;
}
